import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Pages } from 'src/infrastructure/labels/pages';
import { GroupInfo } from 'src/models/DTO/groups/groupInfo';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { Item } from 'src/models/DTO/items/item';
import { ProductOptionCollection } from 'src/models/DTO/options/productOptionCollection';
import { Price } from 'src/models/DTO/prices/price';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { ProductService } from 'src/services/request/product/product.service';
import { ProductOptionService } from 'src/services/request/productOptions/product-option.service';
import { GroupStateService } from 'src/services/state/group/group-state.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';

@Component({
  selector: 'app-join-group',
  templateUrl: './join-group.component.html',
  styleUrls: ['./join-group.component.css']
})
export class JoinGroupComponent extends HistoryBaseComponent implements OnInit {

  private _item? : Item;
  private _itemImages: ImageCollection = { data: [] };
  private _variationsImages: ImageCollection = { data: [] };
  private _partnerLogoImages: ImageCollection = { data: [] };
  private _selectedItemUUID? : string;
  private _userImagesCollection :  { [key: string] : any } = [];
  private _rootCategory : string = '';
  private _pricing: Price[]  = [];
  private _selectedAmount: number = 1;
  private _productOptions: ProductOptionCollection = { data: [] };
  private _currentGroup?: GroupInfo;
  private _groupRequestModel?: CreateGroupOrderRequestModel;

  constructor(
    private groupService: GroupsService,
    private imagesService: ImagesService,
    private productOptionService: ProductOptionService,
    private router: Router,
    private orderStateService: OrederStateService,
    private groupStateService: GroupStateService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
   }

   ngOnInit(): void {

    this.groupStateService.orderInfo$.subscribe(group => {
      if (group.group_uuid) {
        this._groupRequestModel = group;
        this.groupService.getGroup(group.group_uuid).subscribe(group => {
          this._currentGroup = group;
          this.getImagesForUsers(this._currentGroup?.data.participants);
        })
        this._selectedAmount = group.sku.quantity || 1;
        this._item = group.product;
        this._item!.data.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from)
        this.getImagesForVariations();
        this.getImagesForItem(this._item!);
        this.getProductOptions(this._item!);
      }
    })
  }

  get sku() {
    return this._item?.data.skus.find(sku => sku.uuid == this._groupRequestModel?.sku.uuid);
  }

  get group() {
    return this._currentGroup;
  }

  get variations() {
    return this._item?.data.skus.slice(1) || [];
  }

  get groupProduct() {
    return this._item?.data;
  }

  get productImage() {
    return this._itemImages.data[0]?.original.url;
  }

  get selectedAmount() {
    return this._selectedAmount
  }

  get inStock() {
    return this._item?.data.total_available_quantity
  }

  get delivery() {
    let label = "Доставка: "
    if (!this._item?.data.packaging?.delivery_time_in_days) {
      return label + "-";
    }
    return label + this._item?.data.packaging?.delivery_time_in_days + ((this._item?.data.packaging?.delivery_time_in_days == 1) ? ' ден' : ' дни');
  }

  get currentPricing() : Price[] {
    return this._pricing;
  }

  get maxAmountForPricing() {
    return this._item?.data.pricing[this._item?.data.pricing.length - 1].quantity_to.toString() || '';
  }

  get minPriceForPricing() {
    return this._item?.data.pricing[this._item?.data.pricing.length - 1].price_per_piece.toString() || '';
  }

  get isIncreaseButtonDsbld() {
    if (this._item?.data.total_available_quantity) {
      return this.selectedAmount >= this._item?.data.total_available_quantity
    }
    else return true
  }

  private getImagesForUsers(participants: Array<any> = []) {
    participants.forEach(participant => {
      this.imagesService.getImagesForProduct("USER", participant.participant.uuid, 'logo').subscribe((response) => {
        participant.participant.imageURL = response.data[0]?.original.url || '/assets/images/account/account-image-not-found.svg';
      })
    });
  }

  private getImagesForVariations() {
    this.variations!.forEach(sku => {
      this.imagesService.getImagesForProduct("SKU", sku.uuid).subscribe(response => {
        sku.images = response;
        response.data?.forEach(image => {
            image.itemUUID = sku.uuid;
            this._variationsImages.data?.push(image);
          });
      })
    })
  }

  private getProductOptions(item: Item) {
    this.productOptionService.getProductOption(item.data.uuid).subscribe(response => {
      this._productOptions = response;
      const indexOfLastItem = this._productOptions.data.findIndex(option => option.display_name == 'Друго')
      if (indexOfLastItem >= -1) {
        const option = this._productOptions.data.splice(this._productOptions.data.findIndex(option => option.display_name == 'Друго'), 1)[0];
        if (option) {
          this._productOptions.data.push(option);
        }
      }
    });
  }

  private getImagesForItem(item: Item) {
    this.imagesService.getImagesForProduct("PRODUCT", item.data?.uuid).subscribe(response => {
      this._itemImages = response;
    });
  }

  returnOptionValue(option: any) {
    if (option.option.values.length) {
      let optionSelected = option.option.values.find((value: { uuid: any; }) => value.uuid == option.value);
      return optionSelected.value;
    }
    return option.value;
  }

  increaseAmount() {
    if (this._item?.data.total_available_quantity && this.selectedAmount == this._item?.data.total_available_quantity) {
      return;
    }
    this._selectedAmount++;
  }

  decreaseAmount() {
    if (this._selectedAmount == 1) return;
    this._selectedAmount--;
  }

  goToProduct() {
    this.router.navigate(['product/' + this._item?.data.uuid + '/' + 'none'])
  }

  getPricingFor(qty: number) : string {
    if (!this._item) return '0.00';
    let pricing = this._item?.data?.pricing.find((price) => {
      return price.quantity_from <= qty && price.quantity_to >= qty
    });
    if (this._item) {
      if (!pricing) {
        pricing = this._item!.data.pricing[this._item!.data.pricing.length - 1];
      }
      if (!pricing) {
        pricing = this._item!.data.pricing[0];
      }
    }

    return pricing?.price_per_piece || '0.00';
  }

  total() {
    let price = Number.parseFloat(this.getPricingFor(this.selectedAmount + (this._currentGroup?.data.quantity_reserved || 0))).toFixed(2);
    return price;
  }

  allAmount() {
    return (Number.parseFloat(this.total()) * (this.selectedAmount)).toFixed(2)
  }

  totalAmount() {
    let priceArray = this.getPricingFor(this.selectedAmount + (this._currentGroup?.data.quantity_reserved || 0)).toString().split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    priceArray.push(Pages.bg.shared.currency);
    return priceArray;
  }

  getSuggestedDeal() : string {
    if (this._item) {
      let suggestedPrice = this._item?.data?.pricing.find((price) => price.quantity_from > (this._selectedAmount + (this._currentGroup?.data.quantity_reserved || 0)));
      let suggestion = '';
      if (suggestedPrice) {
        suggestion = suggestedPrice.price_per_piece
                    + Pages.bg.shared.valuePerStockFor
                    + suggestedPrice.quantity_from
                    + Pages.bg.shared.stocks
      }
      else {
        let amount = this.selectedAmount + (this._currentGroup?.data.quantity_reserved || 0) - 1;
        while (!suggestedPrice) {
          suggestedPrice = this._item?.data?.pricing.find((price) => price.quantity_from > amount);
          amount--;
        }
        suggestion = suggestedPrice.price_per_piece
                    + Pages.bg.shared.valuePerStockFor
                    + suggestedPrice.quantity_from
                    + '+'
                    + Pages.bg.shared.stocks
      }
      return suggestion;
    }
    return '';
  }

  getFullAmountLabel(amount: number) {
    let stock = Pages.bg.shared.fullStocks;
    if (amount == 1) {
      stock = Pages.bg.shared.fullStock;
    }
    return amount + stock;
  }

  getPricingPerAmount(pricing: string) {
    return pricing + Pages.bg.shared.valuePerStock;
  }

  getPricingAmountBase(amount: string | undefined): number {
    return Number(amount) || 0;
  }

  getStandardUnitPriceBase(): number {
    return Number(this.getPricingFor(1)) || 0;
  }

  getSelectedUnitPriceBase(): number {
    return Number(this.total()) || 0;
  }

  getAllAmountBase(): number {
    return Number(this.allAmount()) || 0;
  }

  getFreeDeliveryThresholdBase(): number {
    return Number(this.groupProduct?.organisation?.free_delivery_after_order_amount) || 0;
  }

  getCourierOfficeDeliveryBase(): number {
    return Number(this.groupProduct?.organisation?.delivery_to_courier_office_price) || 0;
  }

  getAddressDeliveryBase(): number {
    return Number(this.groupProduct?.organisation?.delivery_to_address_price) || 0;
  }

  calculateDiscount(pricingFrom : string, pricingTo : string) {
    const pricing = Number.parseFloat(pricingFrom);
    const priceToConvertion = Number.parseFloat(pricingTo);
    const discount = pricing - priceToConvertion;
    return '-' + Math.round((discount/pricing)*100) + '%';
  }

  deliveryPricingLabel(fee: string | undefined) {
    return fee + Pages.bg.shared.currency;
  }

  createGroup() {
    this._groupRequestModel!.quantity! += this.selectedAmount;
    this._groupRequestModel!.sum = (Number.parseFloat(this.getPricingFor(this._groupRequestModel!.quantity!)) * this.selectedAmount).toFixed(2);
    this._groupRequestModel!.sku.quantity = this.selectedAmount;
    this.groupStateService.addNewOrderInfo(this._groupRequestModel!);
    this.router.navigate(['order/details/group']);
  }
}
